import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../services/briefConfigService";
import { BRIEF_CONFIG_QUERY_KEY } from "@entities/brief/lib/constants";
import { ToastService } from "@shared/lib/services";
import { ICampaignDeliverableTaskApprove } from "@shared/lib/types/briefCampains";
import { BRIEF_CAMPAIGNS_LIST_QUERY_KEY } from "@entities/campaigns/lib/contsants";

export function useRequestEditTaskContent(
  briefId: string,
  handleSuccess?: () => void
) {
  const {
    mutate: requestEditTaskContent,
    isLoading: isRequestingEdit,
    isSuccess: isRequestedEdit,
    variables,
  } = useMutation({
    mutationFn: ({ data }: { data: ICampaignDeliverableTaskApprove }) =>
      BriefConfigService.requestEditTaskContent(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      handleSuccess && handleSuccess();

      c.invalidateQueries({
        queryKey: [...BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId)],
      });
    },
  });

  return {
    requestEditTaskContent,
    isRequestingEdit,
    isRequestedEdit,
    variables,
  };
}
